import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';

import { PickOddsState } from '../../../../../core/picks/pick-models';
import { BetBuilderSelectionModel } from '../../../../single-bet/components/betbuilder-selection.model';

@Component({
    selector: 'bs-linear-bet-builder-selection-display',
    templateUrl: './linear-bet-builder-selection-display.component.html',
    styleUrls: ['./linear-bet-builder-selection-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderSelectionDisplayComponent implements OnChanges {
    @Input() selection: BetBuilderSelectionModel;
    @Input() inlineDetails: boolean;

    constructor(
        private epcotConfig: EpcotConfig,
        sitecore: Sitecore,
    ) {
        this.closedMessage = sitecore.betslip.messages.ClosedPick;
    }

    readonly closedMessage: string;
    readonly pickOddsState = PickOddsState;
    signpostingText?: string;

    ngOnChanges(changes: SimpleChanges): void {
        const selectionChanges = changes.selection;

        if (selectionChanges) {
            const currentSelection = selectionChanges.currentValue as BetBuilderSelectionModel;

            if (!currentSelection || this.pickOddStateLockedOrClosed(currentSelection)) {
                this.signpostingText = undefined;

                return;
            }

            const previousSelection = selectionChanges.previousValue;
            // Check if this is the first change or if any relevant property has changed
            const hasRelevantChange =
                selectionChanges.isFirstChange() ||
                previousSelection?.marketSubTypeSignpostingText !== currentSelection.marketSubTypeSignpostingText ||
                previousSelection?.oddsState !== currentSelection.oddsState;

            if (hasRelevantChange) {
                this.signpostingText = this.selection.marketSubTypeSignpostingText;
            }
        }
    }

    get isEpcotEnabled(): boolean {
        return this.epcotConfig.isEnabled;
    }

    private pickOddStateLockedOrClosed(selection: BetBuilderSelectionModel): boolean {
        return selection && (selection.oddsState === this.pickOddsState.Locked || selection.oddsState === this.pickOddsState.Closed);
    }
}
